"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.loadFacebookSdk = exports.loginWithFacebookSDK = void 0;
var _waitForVar = _interopRequireDefault(require("../../utils/waitForVar"));
const loginWithFacebookSDK = async () => {
  await (0, _waitForVar.default)("FB").then(FB => {
    if (FB == null) {
      return Promise.reject(Error("FB script was not loaded."));
    }
    return FB;
  }).catch(err => {
    throw err;
  });
  return new Promise((resolve, reject) => {
    try {
      FB.login(res => {
        if (!res.authResponse) {
          reject(new Error(res.status));
        }
        resolve(res);
      }, {
        scope: "email,public_profile"
      });
    } catch (e) {
      reject(new Error(String(e)));
    }
  });
};
exports.loginWithFacebookSDK = loginWithFacebookSDK;
const loadFacebookSdk = () => {
  if (typeof window !== "undefined" && typeof FB === "undefined") {
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    window.fbAsyncInit = () => {
      FB.init({
        appId: "332164377117941",
        xfbml: true,
        version: "v10.0"
      });
    };
  }
};
exports.loadFacebookSdk = loadFacebookSdk;
var _default = loginWithFacebookSDK;
exports.default = _default;